import styled from 'styled-components';

import Button from '../interface/Button';

export const CopyrightText = styled.p`
  font-size: var(--font-size-xs);

  @media (${({ theme }) => theme.respondTo.tabletAndMobile}) {
    text-align: center;
    flex-basis: 100%;
    order: 1;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-right: 6rem;
  }
`;

export const Cta = styled.div`
  @media (${({ theme }) => theme.respondTo.tabletAndMobile}) {
    flex-basis: 100%;
    order: -1;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    display: flex;
    align-items: center;
  }
`;

export const CtaButton = styled(Button)`
  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: 100%;
  }
`;

export const CtaTitle = styled.p`
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  margin-right: 2.5rem;

  @media (${({ theme }) => theme.respondTo.mobile}) {
    margin-bottom: 1rem;
  }
`;

export const Links = styled.ul`
  font-size: var(--font-size-xs);
  opacity: 0.6;
  display: flex;
  flex-wrap: wrap;
  margin: 0;

  @media (${({ theme }) => theme.respondTo.tabletAndMobile}) {
    flex-basis: 100%;
    justify-content: center;
    padding: 0 3rem;
  }
`;

export const LinkItem = styled.li`
  margin: 0.5rem 1rem;

  @media (${({ theme }) => theme.respondTo.tabletAndMobile}) {
    margin: 0 1rem 0 0;
  }
`;

export const Nav = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @media (${({ theme }) => theme.respondTo.tabletAndMobile}) {
    width: 100%;
    padding-top: 2rem;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 6rem;
  @media (${({ theme }) => theme.respondTo.mobile}) {
    padding-top: 1rem;
    .login-btn-footer {
      a {
        margin-top: 0;
      }
    }
  }
  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding-top: 3rem;
  }

  @media (${({ theme }) => theme.respondTo.desktopL}) {
    padding-top: 13.5rem;
  }
`;
